
// prod
// const STRIPE_PUBLISHABLE_V2 = "pk_live_DLVTVK7TtIHuHx8MaqCZPbB6"

// uat

const STRIPE_PUBLISHABLE_V2 = "pk_live_DLVTVK7TtIHuHx8MaqCZPbB6"


export default STRIPE_PUBLISHABLE_V2;